import { render, staticRenderFns } from "./video-player-button.vue?vue&type=template&id=6bc6343a&"
import script from "./video-player-button.vue?vue&type=script&lang=ts&"
export * from "./video-player-button.vue?vue&type=script&lang=ts&"
import style0 from "./video-player-button.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports